import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
} from '@vue/composition-api'
import router from '@/router'

export default function usePrivilegeInfo() {
  
  const modeEditor = ref(true)
  const stepActive = ref(0)
  const privilegeId = ref(0)

  const checkFormCreateOrEdit = () => {
    if (router.currentRoute.params.ref) {
      modeEditor.value = false
      privilegeId.value = parseInt(router.currentRoute.params.ref)
    }
  }

  const onGetPrivilegeId = id => {
    privilegeId.value = id
  }

  const scrollToTop = () => {
    const rootEle = document.documentElement
    rootEle.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const onNextStep = () => {
    stepActive.value = stepActive.value++
  }

  const onPreviousStep = () => {
    stepActive.value = stepActive.value--
  }

  onBeforeMount(() => {
    if (localStorage.getItem('activeTab') !== null) {
      stepActive.value = parseInt(localStorage.getItem('activeTab'))
    } else {
      localStorage.setItem('activeTab', stepActive.value)
    }

    checkFormCreateOrEdit()
  })

  watch(
    stepActive,
    () => {
      localStorage.setItem('activeTab', stepActive.value)
    },
    { deep: true },
  )

  return {
    modeEditor,
    stepActive,
    privilegeId,
    scrollToTop,
    onGetPrivilegeId,
    onNextStep,
    onPreviousStep,
  }
}
